import { motion } from "framer-motion";
import { Phone, MapPin, MessageCircle, ArrowUpRight } from "lucide-react";
import { COMPANY } from "../../lib/site";

export const Contact = ({ onQuote }) => {
  return (
    <footer id="contact" data-testid="contact-section" className="relative bg-secondary border-t border-border">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-24 md:py-32">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-7">
            <p className="font-mono text-xs uppercase tracking-[0.2em] text-primary mb-4">/ 04 — Get In Touch</p>
            <motion.h2
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
              className="font-heading text-4xl sm:text-5xl lg:text-7xl font-black uppercase tracking-tighter leading-[0.9]"
            >
              Let&apos;s Get You<br />Running Again
            </motion.h2>
            <button
              data-testid="contact-quote-btn"
              onClick={() => onQuote()}
              className="mt-10 inline-flex items-center gap-2 h-14 px-8 bg-primary text-primary-foreground font-mono text-xs uppercase tracking-[0.2em] font-semibold hover:bg-foreground transition-colors duration-200"
            >
              Request A Quote <ArrowUpRight size={16} />
            </button>
          </div>

          <div className="lg:col-span-5 space-y-8">
            <div>
              <p className="font-mono text-xs uppercase tracking-[0.2em] text-muted-foreground mb-4">Call Us</p>
              <div className="space-y-2">
                {COMPANY.phones.map((p) => (
                  <a
                    key={p.value}
                    href={p.href}
                    data-testid={`contact-phone-${p.value.replace(/\D/g, "")}`}
                    className="flex items-center gap-3 font-heading text-2xl md:text-3xl font-bold tracking-tight hover:text-primary transition-colors"
                  >
                    <Phone size={18} className="text-primary shrink-0" /> {p.value}
                  </a>
                ))}
              </div>
            </div>

            <a
              href={COMPANY.whatsapp}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="contact-whatsapp"
              className="inline-flex items-center gap-2 font-mono text-sm uppercase tracking-wider text-muted-foreground hover:text-primary transition-colors"
            >
              <MessageCircle size={16} /> Chat on WhatsApp
            </a>

            <div>
              <p className="font-mono text-xs uppercase tracking-[0.2em] text-muted-foreground mb-3">Visit Us</p>
              <p className="flex items-start gap-3 font-body text-base text-secondary-foreground max-w-xs">
                <MapPin size={18} className="text-primary shrink-0 mt-1" /> {COMPANY.address}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-border">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <span className="font-heading font-extrabold uppercase tracking-tight text-sm">
            Angmish General Dealers<span className="text-primary">.</span>
          </span>
          <span className="font-mono text-xs text-muted-foreground uppercase tracking-wider">
            © {new Date().getFullYear()} — Lusaka, Zambia
          </span>
        </div>
      </div>
    </footer>
  );
};
